export async function getSeoData() {
  try {
    const res = await fetch("/seo.json");

    if (!res.ok) {
      throw new Error("Failed to fetch SEO data");
    }

    return await res.json();
  } catch (error) {
    console.error("SEO fetch error:", error);
    return null;
  }
}
